import "antd/dist/antd.min.css";
import "antd-button-color/dist/css/style.css";

import React, { useState, useEffect } from "react";
import axios from "axios";

import { Row, Col, Layout, Divider, Button, Menu } from "antd";

import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PieChartOutlined
} from "@ant-design/icons";

import { createGlobalStyle } from "styled-components";

import Dashboard_r from "./Dashboard_r";
import Dashboard_i from "./Dashboard_i";
import Dashboard_he from "./Dashboard_he";
import Dashboard_s from "./Dashboard_s";

import NotIntranetPage from "./NotIntranetPage";

const { Content } = Layout;

const StyledForm = createGlobalStyle`.ant-form-item {
    margin-bottom: 5px;
  }
  `;
const Dashboard_Home = () => {
  let xURL = "";
  let xlocation = window.location.hostname;

  if (xlocation === "localhost") {
    xURL = "http://localhost:3002/api/";
  } else {
    xURL = "https://research.rihes.cmu.ac.th/api/";
  }

  const [collapsed, setCollapsed] = useState(false);
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const [page, _page] = useState(1);

  const items = [
    getItem("R", "1", <PieChartOutlined />),
    getItem("I", "2", <PieChartOutlined />),
    getItem("HE", "3", <PieChartOutlined />),
    getItem("S", "4", <PieChartOutlined />)
  ];

  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type
    };
  }

  const onClick = e => {
    // console.log("click ", e.key);
    _page(e.key);
  };

  const [User_level, _User_level] = useState(0);

  useEffect(() => {
    const token = localStorage.getItem("token");
    var url = new URL(window.location.href);

    if (url.searchParams.get("user") == "guest") {
      _User_level(1);
    } else {
      _User_level(0);
    }

    if (url.searchParams.get("user_id") !== "99") {
      axios
        .get(xURL + "check-ip")
        .then(response => {
          // console.log(response.data.allowed);

          if (response.data.allowed == false) {
            // console.log("not intranet");
            window.open("/notintranetpage", "_self");
          } else {
            console.log("in intranet");
          }
        })
        .catch(error => {
          console.log("problem here", error);
        });
    }
  }, []);

  return (
    <React.Fragment>
      <StyledForm />

      <Content className="site-layout" style={{ padding: "0 0px" }}>
        <Row justify="center" style={{ background: "#f3fbff" }}>
          <Col xs={23} sm={23} md={23} lg={23} xl={23}>
            <Row>
              <h2
                style={{
                  marginTop: "40px",
                  fontSize: "25px",
                  fontWeight: "bold"
                }}
              >
                Dashboard
              </h2>
            </Row>

            <Divider />

            <Row>
              <Col xs={24} sm={8} md={6} lg={4} xl={3}>
                <div
                  style={{
                    width: 150
                  }}
                >
                  <Button
                    type="primary"
                    onClick={toggleCollapsed}
                    style={{
                      marginBottom: 16
                    }}
                  >
                    {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                  </Button>
                  <Menu
                    defaultSelectedKeys={["1"]}
                    defaultOpenKeys={["sub1"]}
                    mode="inline"
                    theme="light"
                    inlineCollapsed={collapsed}
                    items={items}
                    onClick={onClick}
                  />
                </div>
              </Col>

              <Col xs={24} sm={16} md={18} lg={20} xl={21}>
                {page == 1 ? <Dashboard_r level={User_level} /> : <div />}
                {page == 2 ? <Dashboard_i level={User_level} /> : <div />}
                {page == 3 ? <Dashboard_he level={User_level} /> : <div />}
                {page == 4 ? <Dashboard_s level={User_level} /> : <div />}
              </Col>
            </Row>
          </Col>
        </Row>
      </Content>
    </React.Fragment>
  );
};

export default Dashboard_Home;
